<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (tap)="showAll()" size="small" *ngIf="level < 4" fill="outline" shape="round" color="medium">
                All<br>Prods
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Product" debounce="300" [(ngModel)]="queryText">
        </ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchProducts($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Equipment...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-content *ngIf="level === 1">
        <h3 class="ion-padding-start">Select Department</h3>
        <ion-row class="ion-padding">
            <ion-col size="4" *ngFor="let d of deptList | filterDepartment: queryText; index as i;"
                     (click)="refineToGroup(d)">
                <div class="circle" [style.background-color]="pickColor(i)">
                    {{d.descr.length < 3 ? d.descr : d.descr.substr(0, 3)}}
                </div>
                <div class="smalltext">
                    {{d.descr}}
                </div>
            </ion-col>
        </ion-row>
    </ion-content>

    <ion-content *ngIf="level === 2">
        <h3 class="ion-padding-start">Select Group</h3>
        <ion-row padding>
            <ion-col size="4" *ngFor="let g of groupList | filterDepartment: queryText; index as i"
                     (click)="refineToProd(g)">
                <div class="circle" [style.background-color]="pickColor(i)">
                    {{g.descr.length < 3 ? g.descr : g.descr.substr(0, 3)}}
                </div>
                <div class="smalltext">
                    {{g.descr}}
                </div>
            </ion-col>
        </ion-row>
    </ion-content>

    <ion-content *ngIf="level === 3">
        <ion-virtual-scroll [items]="productList | filterDetailLine: queryText">
            <ion-item *virtualItem="let p" (click)="setProduct(p)">
                <ion-label>
                    <h4><strong>{{p.plu}}</strong></h4>
                    <p>{{p.description}}</p>
                </ion-label>
            </ion-item>
        </ion-virtual-scroll>
    </ion-content>

    <ion-content *ngIf="level === 4">
        <ion-card>
            <ion-item>
                <ion-label class="ion-text-center">
                    <h3>Plu: {{product.plu}}</h3>
                </ion-label>
            </ion-item>
            <ion-item>
                <ion-label position="floating"><h4>Description</h4></ion-label>
                <ion-input [(ngModel)]="comment" [value]="comment"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label>Qty:</ion-label>
                <ion-input [(ngModel)]="prodQty" type="number" (ionChange)="calculatePrice()"
                           (click)="$event.target.select()"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label>Price:</ion-label>
                <ion-input [(ngModel)]="weeklyRate" type="number" (ionChange)="calculatePrice(); setDiscount()"
                           (click)="$event.target.select()"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label>Discount, %:</ion-label>
                <ion-input type="number" [(ngModel)]="discount" (ionChange)="calculatePrice()"
                           (click)="$event.target.select()"></ion-input>
            </ion-item>
            <ion-item>
                <ion-label>Total Price: {{ total }} </ion-label>
            </ion-item>
            <ion-list *ngIf="product.ptSerialBeans">
                <ion-list-header *ngIf="product.ptSerialBeans.length > 0">Serials:</ion-list-header>
                <ion-item (click)="editPTSerials()">
                    <ion-label>
                        <p  *ngFor="let ptSerial of product.ptSerialBeans">{{ptSerial.serialNo}}<br></p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-card>
        <ion-fab vertical="bottom" horizontal="end" slot="fixed">
            <ion-fab-button (tap)="addProduct()" color="success">
                <ion-icon name="checkmark"></ion-icon>
            </ion-fab-button>
        </ion-fab>
    </ion-content>
</ion-content>


<ion-footer *ngIf="level < 4">
    <p class="ion-text-center" style="color: darkgrey">Last Update: {{lastUpdate | date: "dd/MM/yyyy HH:mm:ss"}}</p>
</ion-footer>
